(() => {
  const desktopQuery = window.matchMedia('(min-width: 1024px)');
  const exactIcons = {
    trustPremiumTested: `<svg class="senlan-garden-icon senlan-garden-icon--trust-premium-tested" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21V9"/><path d="M12 11c-4.7 0-7.1-2.3-8.1-6 4.3-.9 7.4.7 8.1 4.6"/><path d="M12 9.5c1-4 4.1-5.9 8.1-5.5-.3 3.8-2.8 6.2-8.1 6.3"/><path d="M7.5 21h9"/><path d="M15.2 6.6c1.5-.4 2.7-1.1 3.6-2.1" stroke="var(--ss-olive-500,#718A3A)"/></svg>`,
    trust30DayGuarantee: `<svg class="senlan-garden-icon senlan-garden-icon--trust-30-day-guarantee" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.8 19 5.6v5.2c0 4.5-2.6 8.1-7 10.4-4.4-2.3-7-5.9-7-10.4V5.6L12 2.8Z"/><path d="m8.4 12 2.3 2.3 4.9-5.1" stroke="var(--ss-olive-500,#718A3A)" stroke-width="2"/></svg>`,
    addToCart: `<svg class="senlan-add-to-cart-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2.2l1.7 9.1a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.9-1.4L21 7H7"/><circle cx="10" cy="19" r="1.4"/><circle cx="18" cy="19" r="1.4"/></svg>`,
  };

  const createIconShell = (markup) => {
    const shell = document.createElement('span');
    shell.className = 'senlan-hero-trust__icon';
    shell.innerHTML = markup;
    return shell;
  };

  const ensureAddToCartIcon = (root) => {
    const addToCart = root.querySelector('#AddToCart');
    const label = addToCart?.querySelector('.single-add-to-cart-button--text');
    if (!addToCart || !label || addToCart.disabled || addToCart.classList.contains('sold-out') || label.querySelector('.senlan-add-to-cart-icon')) return;

    const icon = document.createElement('span');
    icon.className = 'senlan-add-to-cart-icon-wrap';
    icon.innerHTML = exactIcons.addToCart;
    label.prepend(icon);
  };

  const mount = (root) => {
    if (!root || root.dataset.senlanDesktopProductV2Mounted === 'true') return;

    const grid = root.querySelector('.product-grid-container');
    const trust = root.querySelector('.senlan-hero-trust');
    const payment = root.querySelector('.product--payment-security');
    const slider = root.querySelector('#Product-Slider');
    const thumbnails = [...root.querySelectorAll('.product-thumbnail-container .product-thumbnail')];
    const inventoryNotice = root.querySelector('inventory-notice.product-inventory-notice--wrapper');
    const variantLabel = root.querySelector('variant-selects .product-form__input--block > .form__label');
    const variantLabelCopy = document.createElement('span');
    variantLabelCopy.className = 'senlan-desktop-v2__variant-label-copy';
    if (!grid || !trust || !payment) return;

    root.dataset.senlanDesktopProductV2Mounted = 'true';
    const originalTrustMarkup = trust.innerHTML;
    ensureAddToCartIcon(root);

    const trustMarker = document.createComment('senlan-desktop-v2-trust');
    const paymentMarker = document.createComment('senlan-desktop-v2-payment');
    const inventoryMarker = inventoryNotice ? document.createComment('senlan-desktop-v2-inventory') : null;
    trust.before(trustMarker);
    payment.before(paymentMarker);
    inventoryNotice?.before(inventoryMarker);

    const rail = document.createElement('aside');
    rail.className = 'senlan-desktop-product-v2__rail';
    rail.setAttribute('aria-label', 'Purchase assurance and payment security');

    const card = document.createElement('div');
    card.className = 'senlan-desktop-product-v2__rail-card';
    rail.append(card);

    const sync = () => {
      if (desktopQuery.matches) {
        if (trust.dataset.senlanMicroFixTrust !== 'true') {
          const labels = {
            premium: trust.dataset.premiumDisplayMode === 'neutral-fallback'
              ? ['Quality', 'Seed Selection', exactIcons.trustPremiumTested]
              : ['Premium', 'Tested Seeds', exactIcons.trustPremiumTested],
            guarantee: ['30-Day', 'Guarantee', exactIcons.trust30DayGuarantee],
            secure: ['Secure', 'Checkout', null],
          };
          [...trust.children].forEach((item) => {
            const [firstLine, secondLine, replacementIcon] = labels[item.dataset.senlanTrustKey] || [];
            if (!firstLine) return;
            const icon = replacementIcon ? createIconShell(replacementIcon) : createIconShell('');
            if (!replacementIcon) {
              const currentIcon = item.querySelector('svg');
              if (currentIcon) icon.replaceChildren(currentIcon);
            }
            const copy = document.createElement('span');
            copy.className = 'senlan-hero-trust__copy';
            const first = document.createElement('span');
            first.className = 'senlan-trust-label__line';
            first.textContent = firstLine;
            const second = document.createElement('span');
            second.className = 'senlan-trust-label__line';
            second.textContent = secondLine;
            copy.append(first, second);
            item.replaceChildren(icon, copy);
          });
          trust.dataset.senlanMicroFixTrust = 'true';
        }
        if (!rail.isConnected) grid.append(rail);
        card.append(trust, payment);
        if (inventoryNotice && variantLabel) {
          variantLabel.classList.add('senlan-desktop-v2__variant-label');
          if (!variantLabelCopy.isConnected) {
            [...variantLabel.childNodes]
              .filter((node) => node !== inventoryNotice)
              .forEach((node) => variantLabelCopy.append(node));
            variantLabel.prepend(variantLabelCopy);
          }
          variantLabel.append(inventoryNotice);
        }
        return;
      }

      if (trust.dataset.senlanMicroFixTrust === 'true') {
        trust.innerHTML = originalTrustMarkup;
        delete trust.dataset.senlanMicroFixTrust;
      }
      trustMarker.after(trust);
      paymentMarker.after(payment);
      if (variantLabelCopy.isConnected && variantLabel) {
        while (variantLabelCopy.firstChild) variantLabel.append(variantLabelCopy.firstChild);
        variantLabelCopy.remove();
      }
      inventoryMarker?.after(inventoryNotice);
      variantLabel?.classList.remove('senlan-desktop-v2__variant-label');
      rail.remove();
    };

    const syncThumbnailSelection = () => {
      const selectedIndex = slider?.flkty?.selectedIndex;
      if (!Number.isInteger(selectedIndex)) return;
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.classList.toggle('senlan-desktop-v2-thumbnail-selected', index === selectedIndex);
      });
    };

    desktopQuery.addEventListener('change', sync);
    slider?.flkty?.on('select', syncThumbnailSelection);
    sync();
    syncThumbnailSelection();
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('.thb-product-detail.senlan-desktop-product-v2').forEach(mount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
})();
